import Helper from '@ember/component/helper';

type Positional = [unknown];

export interface SafeFormatFieldValueSignature {
  Args: {
    Positional: Positional;
  };
  Return: string;
}

/**
 * Coerce a TAS field value (`string | boolean | number | null | Record<…>`,
 * or `unknown` from custom fields) to a displayable string for template
 * content slots that expect a primitive. Non-primitive / null / undefined
 * values render as the empty string.
 *
 * Replaces per-site `{{! @glint-expect-error: field.value is null or record }}`
 * suppressions in TAS templates that read `field.value`.
 *
 *   {{safe-format-field-value field.value}}
 */
export default class SafeFormatFieldValue extends Helper<SafeFormatFieldValueSignature> {
  compute([value]: Positional) {
    if (value == null) return '';
    if (typeof value === 'string') return value;
    if (typeof value === 'number' || typeof value === 'boolean') return String(value);
    if (Array.isArray(value)) {
      return value
        .map((v) =>
          typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' ? String(v) : ''
        )
        .filter(Boolean)
        .join(', ');
    }
    // Records / other objects — not meaningfully displayable inline.
    return '';
  }
}
